// import { request } from '../../lib/request';
import { userDataRequest } from '../../lib/userDataRequest';
import compact from 'lodash-es/compact';
import trim from 'lodash-es/trim';
import omit from 'lodash-es/omit';

export const saveFeature = (feature) => {
  return userDataRequest('post', '/features', {}, false, omit(feature, ['uuid']));
};

export const getUserData = (params) => {
  return userDataRequest('get', '/features', params);
};

export const getImportedData = (featureIds) => {
  const body = { featureIds };
  return userDataRequest('post', '/features/get', {}, false, body);
};

export const getFeatureById = (featureId) => {
  return userDataRequest('get', `/features/${featureId}`);
};

export const updateFeature = (feature) => {
  const featureId = feature.uuid;
  const body = {
    title: feature.title,
    properties: {
      icon: feature.properties.icon,
      color: feature.properties.color,
      strokeType: feature.properties.strokeType,
      strokeWidth: feature.properties.strokeWidth
    },
  };

  if ( feature.notes && feature.notes[0] && feature.notes[0].content && trim(feature.notes[0].content) !== '' ) {
    body.notes = feature.notes;
  }

  return userDataRequest('patch', `/features/${featureId}`, {}, false, body);
};

export const updateBulkFeatureStyles = (featureIds, properties) => {
  const body = {
    featureIds,
    properties,
  };
  return userDataRequest('patch', '/features/styles', {}, false, body);
};

export const deleteFeature = (feature, params) => {
  const featureId = feature.uuid;
  return userDataRequest('delete', `/features/${featureId}`, params);
};

// Accepts an array of featureIds
export const deleteFeatures = (featureIds, params) => {
  const body = { featureIds };
  return userDataRequest('post', '/features/delete', params, false, body);
};

/********************************************************************************/

export const addCollectionsToFeature = (featureId, collectionIds) => {
  const body = { collectionIds: compact(collectionIds) };
  return userDataRequest('patch',`/features/${featureId}/add/collections`,
    {}, false, body);
};

export const removeCollectionsFromFeature = (featureId, collectionIds) => {
  const body = { collectionIds: compact(collectionIds) };
  return userDataRequest('patch',`/features/${featureId}/remove/collections`,
    {}, false, body);
};